import { motion } from "framer-motion";
import { CalendarDays, FileText } from "lucide-react";
import SidebarGalleryPage from "../Main/Sidebargallery";
import cb_banner from "../../assets/Feedback/cb_banner.jpg";
import SchemeSyllabus from "./Scheme&Syllabus";


const academicCalendar = [
  { text: "Academic Calendar for Second Year Diploma Pharmacy.", pdf: "https://www.rgpvdiploma.in/PDF/Pharmacy2nd2025.pdf" },
  { text: "Academic Calendar of July-Dec 2024 for First Semester Diploma Engineering.", pdf: "https://www.rgpvdiploma.in/PDF/JulyDecAC2024.pdf" },
  { text: "Academic Calendar for III, V & VII Semesters of Engineering Diploma July - Dec 2024.", pdf: "https://www.rgpvdiploma.in/PDF/acadmiccalender2024.pdf" },
  { text: "Academic Calendar for II, IV, VI & VII Semesters of Engineering Diploma Feb-June 2024.", pdf: "https://www.rgpvdiploma.in/PDF/Acadmic_cal_febjune2024.pdf" },
  { text: "Pharmacy Diploma Academic Calendar Session 2023-24.", pdf: "https://www.rgpvdiploma.in/PDF/acadmin_cal_p02_aug2023.pdf" },
  { text: "Academic Calendar For Engineering Diploma Courses Session July 2023 to December 2023.", pdf: "https://www.rgpvdiploma.in/PDF/acadmcc2.pdf" },
  { text: "Academic Calendar for Second Semester CME - Feb 2023 to June 2023.", pdf: "https://www.rgpvdiploma.in/PDF/ACADCME2023.pdf" },
  { text: "ACADEMIC CALENDER FOR FIRST YEAR PHARMACY 2022-23.", pdf: "https://www.rgpvdiploma.in/PDF/ACADPHARM.pdf" },
  { text: "Academic Calendar of Diploma CME first Semester September_2022 to January_2023", pdf: "https://www.rgpvdiploma.in/PDF/academicfirstyear.pdf" },
  { text: "Academic Calendar July-Dec 2022 of Diploma Engineering Except First Semester.", pdf: "https://www.rgpvdiploma.in/PDF/Acaedmiccal28Jul2022.pdf" },
];

export default function AcadCalender() {
  return (
    <div className="min-h-screen bg-gray-100 p-6">
      <div className="max-w-7xl mx-auto p-2 md:p-6 flex flex-col lg:flex-row gap-8">
        {/* Left Column */}
        <motion.div
          className="lg:w-2/3"
          initial={{ opacity: 0, x: -20 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.5 }}
        >


          {/* Content */}
          <div className="">

            {/* <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ duration: 0.7 }}
              className="mb-6"
            >
              <img
                src={cb_banner}
                alt="Academic Calendar"
                className="w-full h-auto rounded-lg border-[#00BFA5] border-4 p-2 shadow-lg"
              />
            </motion.div> */}


            <div className="border-4 border-teal-500 rounded-lg p-2">
                <h2 className="text-xl font-bold mb-4 flex items-center justify-between gap-2 bg-[#00BFA5] text-white rounded-sm w-full p-2">
                  <div className="flex items-center gap-2">
                    <CalendarDays className="w-6 h-6" />
                    Academic Calendar
                  </div>
                  <a href="https://www.rgpv.ac.in/academics/frm_AcademicCalender.aspx" className="text-sm text-white underline hover:text-gray-200" target="_blank" rel="noopener noreferrer">
                    View All
                  </a>
                </h2>
                <p className="text-gray-600 mb-4 leading-relaxed">
                  Find the detailed academic schedule for all sessions below:
                </p>
                <ul className="space-y-4">
                  {academicCalendar.map((item, index) => (
                    <motion.li
                      key={index}
                      initial={{ opacity: 0, x: -10 }}
                      animate={{ opacity: 1, x: 0 }}
                      transition={{ delay: 0.2 + index * 0.1 }}
                      className="flex items-center gap-2"
                    >
                      <FileText className="w-5 h-5 text-[#00BFA5]" />
                      <a
                        href={item.pdf}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-blue-500 hover:text-blue-700 underline"
                      >
                        {item.text}
                      </a>
                    </motion.li>
                  ))}
                </ul>
            </div>
          </div>
        </motion.div>

        {/* Right Column - Sidebar */}
        <motion.div
          className="w-full lg:w-4/12"
          initial={{ opacity: 0, x: 20 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.5 }}
        >
          <SidebarGalleryPage />
        </motion.div>
      </div>
      {/* <SchemeSyllabus/> */}
      <button className="bg-[#00BFA5] text-white py-2 px-4 rounded "><a href="https://www.rgpv.ac.in/academics/frm_AcademicCalender.aspx" target="_blank" rel="noopener noreferrer">View All</a></button>
    </div>
  );
}

